import { programDetailsConfig, DetailType } from "../../../../constants";
import { HTMLTagRegEx } from "../../../../../../constants";

type CommonObject = { [key: string]: any };

const requiredTypes: DetailType[] = programDetailsConfig
  .filter((config) => config.isRequired)
  .map((config) => config.type);

const validator = async ({ values, activeTabId, activeStepName }) => {
  const errors: CommonObject = {
    details: {},
  };

  const details = values[activeStepName]?.details || {};

  requiredTypes.forEach((type) => {
    if (
      !details[`type_${type}`] ||
      !details[`type_${type}`].replace(HTMLTagRegEx, "").trim().length
    ) {
      errors.details[`type_${type}`] = "This field is required.";
    }
  });

  if (Object.keys(errors.details).length > 0) {
    throw {
      [activeStepName]: errors,
    };
  }
};

export default validator;
